import {Component, EventEmitter, forwardRef, Input, OnChanges, Output, Provider, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {
  SelectPrestationTypeOption
} from '@shared/module/forms/component/form-prestationType-select/select-prestationType-option';

const SELECT_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormPrestationTypeSelectComponent),
  multi: true,
};

@Component({
  selector: 'app-form-prestationType-select',
  templateUrl: './form-prestationType-select.component.html',
  styleUrls: ['./form-prestationType-select.component.scss'],
  providers: [SELECT_CONTROL_VALUE_ACCESSOR]
})
export class FormPrestationTypeSelectComponent implements ControlValueAccessor, OnChanges {
  @Input() placeholder: string = '';
  @Input() options!: SelectPrestationTypeOption[];
  @Output() add = new EventEmitter<any>();

  show = false;
  selected?: any;
  disabled = false;
  private onTouched!: Function;
  private onChanged!: Function;

  ngOnChanges(changes: SimpleChanges) {
    const selected = this.options?.find(o => o.selected);
    if (selected) {
      this.writeValue(selected);
    }
  }

  selectValue(option: SelectPrestationTypeOption) {
    this.show = false;
    this.selected = option; // <-- call function to let know of a change
  }

  writeValue(option: SelectPrestationTypeOption): void {
    this.selected = option ?? undefined;
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn; // <-- save the function
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn; // <-- save the function
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  onClickAdd(): void {
    if (this.selected) {
      this.add.emit(this.selected?.value);
    } else {
      this.show = true;
    }
  }
}
